import { useFormContext } from "../../context/form-context"
import { HintButton } from "./hint"

export const Textarea = (props) => {
  const {
    inFormValues,
    removeValue,
    toggleValue,
    step: stepId,
    setModalData,
  } = useFormContext()
  const { name, label } = props
  const storedObj = inFormValues({ name })

  const onChange = (e) => {
    const { value } = e.target

    // simply remove object from store if value is empty, i.e. toggle again.
    if (value === "") removeValue(name)
    else {
      toggleValue(
        {
          step: stepId,
          name,
          label,
          value,
        },
        true,
      )
    }
  }

  return (
    <div class="textarea-wrap">
      <textarea
        name={props.name}
        class={props.class}
        value={storedObj?.value}
        onChange={onChange}
        maxLength="1000"
        rows="6"
        placeholder={props.placeholder}
      />
      {props.hint && (
        <HintButton
          title={props.hint.title}
          onClick={() => {
            setModalData(props.hint)
          }}
        />
      )}
    </div>
  )
}
